import { z } from 'zod';
import { ExportState } from '@mews-commander/data-access';
import { createDateTimeSchema, dateTimeUtcStringSchema } from '@mews/framework';
import { FilterValueKey } from '../constants';

export interface ExportsResult {
    id: string;
    type: string;
    exportSchedule: string | null;
    created: string;
    status: string;
    fileLink?: string | null;
}
export const exportFiltersSchema = z
    .object({
        [FilterValueKey.startDate]: dateTimeUtcStringSchema,
        [FilterValueKey.endDate]: dateTimeUtcStringSchema,
        [FilterValueKey.states]: z.array(z.nativeEnum(ExportState)).nullish(),
        [FilterValueKey.reportType]: z.string().nullish(),
        [FilterValueKey.ownerProfileId]: z.string().nullish(),
    })
    .extend<{}>(createDateTimeSchema({ fieldName: FilterValueKey.startDate, required: true }))
    .extend<{}>(createDateTimeSchema({ fieldName: FilterValueKey.endDate, required: true }));

export type ExportFilterValues = z.infer<typeof exportFiltersSchema>;

const exportFilterSchema = z.object({
    Name: z.string().nullable(),
    Value: z.string().nullable(),
    Type: z.string().nullable(),
});

export const filtersSchema = z.array(z.array(exportFilterSchema)).min(1);

export type ExportFilter = z.infer<typeof exportFilterSchema>;
